import React, { useContext } from 'react'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'react-i18next'
import { TabProps } from '../../../models/Sample'
import { ViewSampleDetailsRow } from './ViewSampleDetailsRow'
import { MASTER_DATA_KEYS as MDK, MASTER_DATA_ID as MDI } from '../../../utils/constants'
import { MasterDataContext } from '../../../contexts'
import { AppUtil } from '../../../utils/app.utils'
import _ from 'lodash'
import { FamilyHistoryDetails } from './FamilyHistoryDetails'

export const FamilyHistory = (props: TabProps) => {
  const { sampleDetails } = props
  const { t } = useTranslation()
  const translatn = 'viewSample.'
  const { masterData } = useContext(MasterDataContext)
  const parentClass = ''
  const detailsArr = [
    {
      label: t(`${translatn}familyHistory`),
      value: AppUtil.getLabel(MDK.FAMILY_HISTORY, masterData, sampleDetails?.familyHistoryOfCancer),
      show: true,
    },
  ]

  const data = detailsArr.filter((details) => details.show === true)

  const rowCount = _.chunk(data, 5)

  return (
    <Container fluid>
      <h5 className="fw-bold "> {t(`${translatn}familyHistory`)}</h5>
      {rowCount.map((row, index) => {
        return (
          <>
            <ViewSampleDetailsRow key={index} index={index} rowArr={rowCount[index]} parentClass={parentClass} />
          </>
        )
      })}
      {sampleDetails?.familyHistoryOfCancer == MDI.FAMILY_HISTORY_OF_CANCER_OPTION_YES &&
        <FamilyHistoryDetails sampleDetails={sampleDetails} />
      }
    </Container>
  )
}
